import moment from "moment";
import Vue from 'vue';
import { router } from '@/router';
import ReportsService from '@/services/ReportsService';
import _ from 'lodash';
import store from '@/store';


function initialState() {
    return {
        ExpiryReportsExcelFileName: null,
        ExpiryReportsPDFFileName: null,
        dropDownObject: {
            fromDate: null,
            endDate: null,
            cinema_name: null,
            cinema_id: null,
        },
        ExpiryReport: [],
    }
}

const state = initialState();

const mutations = {
    SET_EXPIRY_EXCEL_FILE_NAME: (state, payload) => {
        state.ExpiryReportsExcelFileName = payload;
    },
    SET_EXPIRY_PDF_FILE_NAME: (state, payload) => {
        state.ExpiryReportsPDFFileName = payload;
    },
    SET_EXPIRY_DROP_DOWN_VALUES: (state, payload) => {
        switch (payload.name) {
            case 'isCinema':
                state.dropDownObject.cinema_id = payload['selectedItem'] ? payload.selectedItem.cine_id : null;
                state.dropDownObject.cinema_name = payload['selectedItem'] ? payload.selectedItem.cine_name : null;
                break;
            case 'fromDate':
                state.dropDownObject.fromDate = payload['event'] ? payload['event'] : null;
                break;
            case 'endDate':
                state.dropDownObject.endDate = payload['event'] ? payload['event'] : null;
                break;
            default: console.log('Municipalty Report :( Sorry, we are enable to set value.');
        }
    },
    SET_EXPIRY_REPORT: (state, payload) => {
        state.ExpiryReport = payload || []
    }
}

const actions = {
    onExpiryReportDropDownHandler: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_EXPIRY_DROP_DOWN_VALUES', payload);
    },
    ClearReportData: ({ dispatch, commit, state }, payload) => {
        commit('SET_EXPIRY_REPORT', payload)
    },
    onFetchExpiryReport: async ({ dispatch, commit, state }, payload) => {
        await commit('SET_EXPIRY_REPORT', [])
        let loader = Vue.$loading.show();
        await ReportsService.GetExpiryReports(state.dropDownObject)
            .then(async (response) => {
                loader.hide();
                const { data } = response;
                if (data.status) {
                    commit('SET_EXPIRY_REPORT', data.Records)
                    await commit('SET_EXPIRY_EXCEL_FILE_NAME', data['FinalExcelFile'] || null);
                    await commit('SET_EXPIRY_PDF_FILE_NAME', data['FinalPDFFile'] || null);
                } else {
                    Vue.toasted.show(data.message);
                }
            }).catch((error) => {
                Vue.toasted.show("Catch Error on Municipalty Reports", error);
            });
    },
}

const getters = {
    getExpiryReportsSelectedCinema: state => state.dropDownObject.cinema_name,
    getExpiryReportFromDate: state => state.dropDownObject.fromDate,
    getExpiryReportEndDate: state => state.dropDownObject.endDate,
    getExpiryReportData: state => state.ExpiryReport,

    getExpiryReportsExcelFileName: state => state.ExpiryReportsExcelFileName,
    getExpiryReportsPDFFileName: state => state.ExpiryReportsPDFFileName,
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/ExpiryReportStore.js